import { useState } from "react";
import { faqData } from "@/mocks/faq";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section className="w-full bg-[#F5F5F5] py-12 md:py-16 lg:py-20 scroll-mt-20" id="faq">
      <div className="section-container">
        {/* Section Header */}
        <div className="text-center mb-10 md:mb-14">
          <span className="text-gamo-green text-xs tracking-[0.2em] block mb-3">● FAQ</span>
          <h2 className="text-gamo-black text-2xl md:text-3xl font-bold tracking-wide">
            よくあるご質問
          </h2>
          <div className="w-10 h-px bg-gamo-green mx-auto mt-4" />
        </div>

        {/* Accordion List */}
        <div className="max-w-3xl mx-auto space-y-3">
          {faqData.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.question}
                className="bg-white border border-gamo-border-gray rounded-lg overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => toggle(index)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer transition-colors hover:bg-gamo-light-gray"
                >
                  <span className="flex items-start gap-3">
                    <span className="text-gamo-green font-bold text-sm md:text-base leading-relaxed">
                      Q.
                    </span>
                    <span className="text-gamo-dark-gray text-sm md:text-base font-medium leading-relaxed">
                      {item.question}
                    </span>
                  </span>
                  <span
                    className={`w-8 h-8 flex items-center justify-center flex-shrink-0 rounded-full transition-all duration-300 ${
                      isOpen
                        ? "bg-gamo-green text-white rotate-180"
                        : "bg-gamo-light-gray text-gamo-medium-gray"
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </span>
                </button>

                <div
                  className={`${
                    isOpen
                      ? "px-5 md:px-6 pb-5 md:pb-6 animate-fade-in"
                      : "hidden"
                  }`}
                >
                  <div className="flex items-start gap-3 border-t border-gamo-border-gray pt-4">
                    <span className="text-gamo-green font-bold text-sm md:text-base leading-relaxed">
                      A.
                    </span>
                    <p className="text-gamo-medium-gray text-sm leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}